import styled from 'styled-components'

export const TradeCard = styled.div`
  background: #12131a;
  width: calc(25% - 24px);
  max-width: 288px;
  min-width: 220px;
  height: 133px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  margin: 12px;
  h3 {
    font-size: 30px;
    line-height: 1.33;
  }
  p {
    font-size: 12px;
    color: var(--title-color);
    padding-top: 12px;
    text-transform: uppercase;
    line-height: 1.5;
  }
  @media screen and (max-width: 599px) {
    height: unset;
    h3 {
      font-size: 24px;
    }
  }

`